import { render, staticRenderFns } from "./statAppointXiangmuZhiye.vue?vue&type=template&id=716f6b9e&scoped=true"
import script from "./statAppointXiangmuZhiye.vue?vue&type=script&lang=js"
export * from "./statAppointXiangmuZhiye.vue?vue&type=script&lang=js"
import style0 from "./statAppointXiangmuZhiye.vue?vue&type=style&index=0&id=716f6b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f6b9e",
  null
  
)

export default component.exports